
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class CommonReportTab extends Vue {
  @Prop() private homePageTabList!: Array<object>;
  changeActive(item: any) {
    if (item.isActive) {
      return {
        background: 'rgba(0,0,0,0.04)',
        color: 'rgba(0,0,0,0.84)',
        border: 'none',
      };
    } else {
      return false;
    }
  }
  changeTab(item: any) {
    this.$emit('tabChange', item);
    for (let i: number = 0; i < this.homePageTabList.length; i++) {
      this.homePageTabList[i] as any;
      this.homePageTabList[i]['isActive'] = false;
    }
    item.isActive = true;
  }
}
